const ROOT = 'User/editUser/getValues';

export const FETCH_FILTER_VALUES_REQUEST = `${ROOT}/FETCH_FILTER_VALUES_REQUEST`;
export const FETCH_FILTER_VALUES_SUCCESS = `${ROOT}/FETCH_FILTER_VALUES_SUCCESS`;
export const FETCH_FILTER_VALUES_FAILURE = `${ROOT}/FETCH_FILTER_VALUES_FAILURE`;
export const FETCH_GET_IDUSER = `${ROOT}/FETCH_GET_IDUSER`;
export const FETCH_REFRESHTOKEN_REQUEST = `${ROOT}/FETCH_REFRESHTOKEN_REQUEST`;
